<template>
  <ODialog ref="dialog" :maxWidth="700" hideWhenLoading>
    <v-card v-if="row != null">
      <ODialogBar
        title="Firmware"
        :subtitle="row.id ? '#' + row.id : ''"
        @close="$refs.dialog.$dismiss"
      />

      <v-card-text class="pa-3 children-ma-3 v-row">
        <div>
          <v-text-field v-model="row.name" label="Nome" hide-details required />
        </div>
        <div>
          <v-text-field
            v-model="row.version"
            label="Versão"
            prefix="(dec)"
            hide-details
            required
          />
        </div>
        <div class="grey lighten-5 pa-3">
          <div class="h-row">
            Arquivo: {{ row.size }} bytes <br />
            Checksum: {{ row.sum }} (0x{{
              parseInt(row.sum || 0).toString(16)
            }})
            <v-spacer />
            <v-btn text @click="download">
              <v-icon>download</v-icon>
              Download
            </v-btn>
            <v-btn text class="ml-2" @click="upload">
              <v-icon>upload</v-icon>
              Upload
            </v-btn>
          </div>
        </div>
        <v-alert
          v-if="fileDirty"
          dense
          icon="mdi-alert-circle"
          color="orange"
          outlined
        >
          O arquivo foi alterado. Não esqueça de clicar "Salvar" para gravar as
          alterações.
        </v-alert>

        <div class="h-row mt-4">
          <div class="cap-cont oderon-col-4">
            <label>Criado em</label>
            <p>{{ row.createdAt | moment('YYYY-MM-DD HH:mm') }}</p>
          </div>

          <div class="cap-cont oderon-col-4">
            <label>Atualizado em</label>
            <p>{{ row.updatedAt | moment('YYYY-MM-DD HH:mm') }}</p>
          </div>

          <div class="cap-cont oderon-col-4">
            <label>Desativado em</label>
            <p>{{ row.deletedAt | moment('YYYY-MM-DD HH:mm') }}</p>
          </div>
        </div>
      </v-card-text>
      <ODialogButtons
        class="pa-6"
        @apply="apply"
        @cancel="$refs.dialog.$dismiss()"
      />
    </v-card>
  </ODialog>
</template>

<script>
import { Firmware } from '@/models'
import { saveBlobAs, openBlob, letters } from 'oderon-vue/utils'

export default {
  data() {
    return this.reset()
  },
  methods: {
    reset() {
      return {
        row: null,
        fileDirty: false
      }
    },

    open(id) {
      Object.assign(this, this.reset())
      this.id = id
      this.$refs.dialog.$loading(() => this.fetchData())
      return this.$refs.dialog.$open()
    },

    async fetchData() {
      if (this.id != null) {
        let row = await Firmware.findById(this.id)
        this.row = row
        this.fileDirty = false
      } else {
        this.row = { size: 0, name: null, version: null }
        this.fileDirty = false
      }
    },

    async download() {
      let blob = await Firmware.getBlob(this.id)
      let deburred = letters(this.row.name)
      saveBlobAs(blob, `firmware-${deburred}.bin`)
    },

    async upload() {
      let blob = await openBlob()
      this.row.size = blob.size
      this.row.blob = blob
      this.fileDirty = true
    },

    async apply() {
      let data = new FormData()
      let add = (field, val) => {
        if (val) data.append(field, val)
      }

      add('name', this.row.name)
      add('id', +this.row.id)
      add('version', +this.row.version)
      add('file', this.row.blob)

      await this.$refs.dialog.$loading(async () => {
        await Firmware.save(data)
        this.$refs.dialog.$dismiss()
        this.$snack('Salvo com sucesso')
      })

      this.$emit('reload')
    }
  }
}
</script>

<style></style>
